module.exports = __webpack_public_path__ + "ionicons.05acfdb568b3df49ad31.woff";


//////////////////
// WEBPACK FOOTER
// D:/MMC App/MMC/src/bower_components/Ionicons/fonts/ionicons.woff?v=2.0.0
// module id = ../../../../../src/bower_components/Ionicons/fonts/ionicons.woff?v=2.0.0
// module chunks = 2